import router from '@/router'

const handler = err => err ? 'ok' : 'ok'

export const namespaced = true

export const state = () => ({
  department: null,
  manager: null,
  status: [],
  priority: [],
  dateRange: null
})

export const getters = {
  department (state) {
    return state.department
  },
  manager (state) {
    return state.manager
  },
  status (state) {
    return state.status
  },
  priority (state) {
    return state.priority
  },
  dateRange (state) {
    return state.dateRange
  }
}

export const mutations = {
  SET_DEPARTMENT (state, org) {
    state.department = org
  },
  SET_MANAGER (state, man) {
    state.manager = man
  },
  SET_STATUS (state, status) {
    state.status = status
  },
  SET_PRIORITY (state, priority) {
    state.priority = priority
  },
  SET_DATE_RANGE (state, dr) {
    state.dateRange = dr
  }
}

export const actions = {
  setDepartment ({ commit, dispatch }, org) {
    commit('SET_DEPARTMENT', org)
    router.push({ name: 'claims' }).catch(handler)
    dispatch('claim/load', null, { root: true })
  },
  setManager ({ commit, dispatch }, man) {
    commit('SET_MANAGER', man)
    router.push({ name: 'claims' }).catch(handler)

    dispatch('claim/load', null, { root: true })
  },
  setPriority ({ commit, dispatch }, pri) {
    commit('SET_PRIORITY', pri)
    router.push({ name: 'claims' }).catch(handler)

    dispatch('claim/load', null, { root: true })
  },
  setDateRange ({ commit, dispatch }, dr) {
    commit('SET_DATE_RANGE', dr)
    router.push({ name: 'claims' }).catch(handler)

    dispatch('claim/load', null, { root: true })
  },
  setStatus ({ commit, dispatch }, sta) {
    commit('SET_STATUS', sta)
    router.push({ name: 'claims' }).catch(handler)

    dispatch('claim/load', null, { root: true })
  }
}
